import React from 'react';
import "../../styles/components/common/CenteredTitle.css"

const CenteredTitleComp = ({ title, style }) => {
    return (
        <h2 className="centered-title" style={style}>{title}</h2>
    );
};

export default CenteredTitleComp;